/* eslint-disable */
import Vue from 'vue';

import store from './../../store';

export default () => {
  ga('send', 'event', 'Button', 'click', 'Header: Logout');
  store.dispatch('logout');
  Vue.router.replace({
    name: 'home',
  });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/logout.js